/**
 * Get the current search filter based on the search input field.
 *
 * @author rafhun <rafhun@cubetech.ch>
 *
 * @param {HTMLElement} parent
 * @returns string|false
 */
export function getSearchField(parent) {
    const search = parent.querySelector('[data-ct-filter-type="search"] input[type="search"]');

    if (search) {
        const { name, value } = search;

        if (value && value !== '') {
            const searchObject = {};
            searchObject[name] = value;
            return new URLSearchParams(searchObject).toString();
        }
    }

    return false;
}
